import { formDataShow, completeTask, recallProcess } from '@/http/url'
let formData = []
// 非空判断  空-true  非空-false
export function isEmpty(data) {
  if (!data) {
    return true
  }
  if (JSON.stringify(data) === '{}') {
    return true
  }
  if (JSON.stringify(data) === '[]') {
    return true
  }
  return false
}
// 金额小写转大写
export function priceChange(number) {
  let ret = "";
  if (number != "" && number != null && number != "0") {
    let unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
      str = "";
    number += "00";
    let point = number.indexOf(".");
    if (point >= 0) {
      number = number.substring(0, point) + number.substr(point + 1, 2);
    }
    unit = unit.substr(unit.length - number.length);
    for (let i = 0; i < number.length; i++) {
      str +=
        "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
    }
    ret =
      str
        .replace(/零(仟|佰|拾|角)/g, "零")
        .replace(/(零)+/g, "零")
        .replace(/零(万|亿|元)/g, "$1")
        .replace(/(亿)万|(拾)/g, "$1$2")
        .replace(/^元零?|零分/g, "")
        .replace(/元$/g, "元") + "整";
  }
  return ret
}
// 时间格式化
export function formatTime(jsondate) {
  return new Date(jsondate).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
}

export function activitiSubmission(proQueryParamsObj, filterRadioParams, that) {
  const params = {
    taskId: proQueryParamsObj.taskId
  }
  formDataShow(params).then((res) => {
    if (res.data.code === 0) {
      formData = res.data.data
      let filterRadio = []
      let activitiN1 = []
      let activitiN2 = []
      // 同意 不同意
      let letActivitiN1 = formData.filter((item) => {
        if (item.fieldType === 'radio') {
          let splitSemicolon = item.initFieldValue.split(';')
          splitSemicolon.forEach((el, index) => {
            let colon = String(el).split(':')
            filterRadio.push(colon)
          })
          return item.fieldType === 'radio'
        }
      })
      // 1 提交 2 取消
      filterRadioParams === '1' ? filterRadio[0][0] : filterRadio[1][0]
      activitiN1 = letActivitiN1
      // 审批意见
      let letActivitiN2 = formData.filter(
        (item) => item.fieldType === 'string'
      )
      activitiN2 = letActivitiN2
      activitiCompleteTask(proQueryParamsObj, filterRadioParams, that)
    } else {
      that.$message.error(res.data.msg)
    }
  })
}
export function activitiCompleteTask(proQueryParamsObj, filterRadioParams, that) {
  let formList = []
  formData.forEach((el, index) => {
    formList.push({
      businessKey: proQueryParamsObj.id,
      fieldKey: el.fieldKey,
      fieldName: el.fieldName,
      fieldType: el.fieldType,
      fieldValue: index === 0 ? filterRadioParams : '',
      formStep: proQueryParamsObj.formStep,
      formkey: el.formkey,
      initFieldValue: el.initFieldValue,
      isEdit: proQueryParamsObj.isEdit,
      processDefinitionId: el.processDefinitionId,
      processDefinitionKey: el.processDefinitionKey,
      processInstanceId: el.processInstanceId,
      taskId: proQueryParamsObj.taskId,
      taskName: el.taskName,
      userTaskId: el.userTaskId,
      whetherParam: el.whetherParam
    })
  })
  const params = {
    formList,
    taskId: proQueryParamsObj.taskId,
    operationType: filterRadioParams === '2' ? 4 : '',
    appId: proQueryParamsObj.detailsData.appId ? proQueryParamsObj.detailsData.appId : ''
  }
  completeTask(params).then((res) => {
    if (res.data.code === 0) {
      that.$router.push({
        path: '/'
      })
      that.formData = []
      if (filterRadioParams === '2') {
        that.$message.success('删除成功')
      } else {
        that.$message.success('审批成功')
      }
      that.confirmLoading = false
    }
  })
}
// 手机号格式校验
export function filterPhone(phoneValue) {
  let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return reg.test(phoneValue)
}
// 已提交 未审核 可撤回流程
export function recallProcessFn(that, record, resolve, reject, recallUrl) {
  that.$confirm({
    title: '确定要撤回吗?',
    okType: 'danger',
    onOk: () => {
      console.log('确认')
      recallProcess({ id: record.id }, recallUrl).then((res) => {
        if (res.data.code == 0) {
          that.$message.success('撤回成功');
          resolve(res)
        } else {
          reject(res)
        }
      })
    },
    onCancel() {
      console.log('Cancel');
    },
  })
}


// WEBPACK FOOTER //
// ./src/utils/utils.js